<template>
    <AppPage title="Visualizar pedido" :subtitle="pageSubtitle" :check-user-permission="false">

        <changeOrderStatus slot="actions" :id="id" :set-status="order.status" v-if="isAdminUser && order.status"/>

        <router-link :to="{name: 'user.orders'}" class="button is-text" slot="actions" v-if="!isAdminUser">Meus
            Pedidos
        </router-link>

        <div class="columns is-desktop" v-if="loaded">

            <div class="column is-4-desktop">
                <h3 class="title is-3">Informações do pedido</h3>
                <p class="subtitle">número: {{ order.number }}</p>
                <table class="table is-fullwidth is-striped is-middle is-bordered">
                    <tr>
                        <th>Criado em</th>
                        <td>{{ order.createdAt | moment('LLL') }}</td>
                    </tr>
                    <tr>
                        <th>Última atualização</th>
                        <td>{{ order.updatedAt | moment('LLL') }}</td>
                    </tr>
                    <tr>
                        <th>Usuário</th>
                        <td>
                            <div>{{ order.user.name }}</div>
                            <a :href="`mailto:${order.user.email}`">{{ order.user.email }}</a>
                            <div v-if="order.user.phone">{{ order.user.phone }}</div>
                        </td>
                    </tr>
                    <tr v-if="order.comment">
                        <th>Observações</th>
                        <td>{{ order.comment }}</td>
                    </tr>
                    <tr>
                        <th>Valor Total</th>
                        <td>{{ order.totalPrice | money }}</td>
                    </tr>
                </table>
            </div>

            <div class="column">
                <hr class="is-hidden-desktop">
                <h3 class="title is-3">Produtos</h3>
                <p class="subtitle">Total de produtos: {{ order.totalProducts }}</p>

                <div class="table-container" v-if="products.length">
                    <table class="table is-fullwidth is-striped is-middle is-bordered">
                        <thead>
                        <tr>
                            <th>Produto</th>
                            <th>Quantidade</th>
                            <th>Valor</th>
                            <th>Valor Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="product in products" :key="product.productId">
                            <td>
                                {{ product.name }}
                                <div class="is-small">#{{ product.code }}</div>
                            </td>
                            <td>{{ product.quantity }} {{ product.measureUnit }}</td>
                            <td>{{ product.unitPrice | money }}</td>
                            <td>{{ product.totalPrice | money }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </AppPage>
</template>

<script>
import AppPage from "@/components/AppPage";
import changeOrderStatus from "./changeOrderStatus";
import database from "@/services/database";
import {mapGetters} from "vuex";

export default {
    name: "viewOrderPage",
    components: {AppPage, changeOrderStatus},

    props: {
        id: {
            required: true
        }
    },

    data() {
        return {
            loaded: false,
            order: {
                user: {},
                number: 0,
                status: null
            },
            products: []
        }
    },

    computed: {
        ...mapGetters(['isAdminUser']),
        pageSubtitle() {
            return `Número #${this.order.number}`;
        }
    },

    watch: {
        id() {
            this.loadOrder();
        }
    },

    methods: {
        async loadOrder() {

            this.loaded = false;

            const loading = this.$buefy.loading.open();

            const orderQuery = database.collection('orders').doc(this.id)
            const orderDocument = await orderQuery.get();
            if (orderDocument.exists) {

                this.order = orderDocument.data();

                // const productsList = await orderQuery.collection('products').get();
                // const products = [];
                // productsList.forEach((product) => {
                //     products.push(product.data());
                // });
                //
                // this.products = products;

                this.products = this.order.products;
                
                this.loaded = true;

            } else {

                const self = this;
                this.$buefy.dialog.alert({
                    title: 'Ops aconteceu um erro',
                    message: 'Este pedido não existe',
                    type: "is-danger",
                    confirmText: 'Entendi',
                    onConfirm() {
                        self.$router.push({name: 'orders'});
                    }
                });

            }

            loading.close();
        }
    },

    created() {
        this.loadOrder();
    }

}
</script>
